export default {
  error: 0,
  success: 1,
  timeout: 2,
  bleDisabled: 3, // not relevant for web app
  wifiDisabled: 4, // not relevant for web app
  idTokenFail: 5,
};

